import { authConfig } from "../apiConfig";

// for get all completed Employee utilization_reports
export const get_employee_utilization_reports_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`generateMonthlyEmployeeUtilizationReport`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};